import { Component, input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DefaultSelectionValue, FormGroupValue, InputProps } from '@miq/shared-models';
import { FilterBarLabelComponent } from '../../filter-bar-label/filter-bar-label.component';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-equals-filter',
  templateUrl: './equals-filter.component.html',
  styleUrl: './equals-filter.component.scss',
  imports: [FilterBarLabelComponent, MatFormField, MatInput, FormsModule, ReactiveFormsModule],
})
export class EqualsFilterComponent<T = DefaultSelectionValue> implements OnInit {
  props = input<InputProps<T>>();
  emitKeyField = input(false);
  search = output<FormGroupValue<T> | string>();
  control: FormControl<T | T[] | null>;
  ngOnInit(): void {
    this.control = new FormControl<T | T[] | null>(this.props().value ?? null, this.props().controlOptions || {});
  }
  doSearch($event) {
    const { value } = $event.target;
    this.control.setValue(value);
    if (this.emitKeyField() && this.props()?.key) {
      this.search.emit({ [this.props().key]: value });
    } else if (this.props()?.field) {
      this.search.emit({ [this.props().field]: value });
    } else {
      this.search.emit(value);
    }
  }
}
